"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.circle_checkmark = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const circle_checkmark = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'circle-checkmark-solid', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 17.1191C13.5899 17.1191 16.5 14.2089 16.5 10.6191C16.5 7.02923 13.5898 4.11908 10 4.11908C6.41015 4.11908 3.5 7.02923 3.5 10.6191C3.5 14.2089 6.41015 17.1191 10 17.1191ZM10 18.6191C14.4183 18.6191 18 15.0374 18 10.6191C18 6.2008 14.4183 2.61908 10 2.61908C5.58172 2.61908 2 6.2008 2 10.6191C2 15.0374 5.58172 18.6191 10 18.6191Z", fill: "#4B5563" }),
        react_1.default.createElement("path", { d: "M12.1875 7.909C12.5759 7.52198 13.2042 7.52251 13.5919 7.91018C13.98 8.29832 13.9801 8.92761 13.5919 9.31575L9.20125 13.7065C8.81106 14.0967 8.17842 14.0967 7.78823 13.7065C7.39757 13.3158 7.3981 12.6823 7.78942 12.2923L12.1875 7.909Z", fill: "#4B5563" }),
        react_1.default.createElement("path", { d: "M6.28901 12.162C5.90275 11.7732 5.9038 11.1452 6.29134 10.7577C6.67979 10.3692 7.30959 10.3692 7.69805 10.7576L9.23799 12.2975C9.62788 12.6874 9.62788 13.3195 9.23801 13.7094C8.84722 14.1002 8.2133 14.0991 7.82381 13.7071L6.28901 12.162Z", fill: "#4B5563" })));
};
exports.circle_checkmark = circle_checkmark;
